import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useAppApi } from "@/App";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function MarketErrorScreen() {
    return (
        <DefaultLayout>
            <List />
        </DefaultLayout>
    );
}

function List() {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:market:error:list"));

    if (!apiData) return;

    return (
        <ListingCard header={t("Заказы с ошибками")}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Email</th>
                        <th>{t("Игра")}</th>
                        <th>{t("Состояние")}</th>
                        <th>{t("Дата заказа")}</th>
                        <th>{t("Ошибка платежа")}</th>
                        <th>{t("Ошибка генерации серийника")}</th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o) => {
                        return (
                            <tr key={`object_list${o.id}`}>
                                <td>{o.id}</td>
                                <td>{o.email}</td>
                                <td>
                                    <Link to={url_reverse("games:statistics:orders", { game_id: o.game.id })}>
                                        {o.game?.base_locale_object.name}
                                    </Link>
                                </td>
                                <td>{o.state}</td>
                                <td>{o.date_ordered}</td>
                                <td>{o.payment_error}</td>
                                <td>{o.serial_error}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </ListingCard>
    );
}
